(() => {
  if (window.waReadingSizeV2) return;
  window.waReadingSizeV2 = true;
  const key = 'wa-reading-size-v1';
  const levels = [1, 1.15, 1.3];
  const selector = '#MainContent :is(h1,h2,h3,h4,h5,h6,p,li,dt,dd,label,button,input,textarea,select,a,span,strong,small,legend,summary,blockquote,figcaption), footer :is(p,a,label)';
  const excluded = '[data-wa-reading],svg,[aria-hidden="true"],[role="img"],script,style,noscript,iframe,[data-wa-reading-exclude]';
  const originals = new Map();
  let factor = 1;
  let storageAvailable = true;
  let frame = 0;
  let lastNotice = 'current';

  function valid(value) {
    const number = Number(value);
    return levels.includes(number) ? number : 1;
  }

  try { factor = valid(localStorage.getItem(key)); } catch (_) { storageAvailable = false; }

  function restore() {
    originals.forEach((value, element) => {
      if (value) element.style.setProperty('font-size', value.value, value.priority);
      else element.style.removeProperty('font-size');
    });
    originals.clear();
  }

  function syncControls() {
    document.querySelectorAll('[data-wa-reading]').forEach(panel => {
      panel.hidden = false;
      panel.querySelectorAll('[data-wa-size]').forEach(button => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.waSize) === factor));
      });
      const status = panel.querySelector('[data-wa-size-status]');
      const template = !storageAvailable ? panel.dataset.waStatusUnavailable : lastNotice === 'reset' ? panel.dataset.waStatusReset : panel.dataset.waStatusSaved;
      if (status && template) {
        const message = template.replace('{percent}', String(Math.round(factor * 100)));
        if (status.textContent !== message) status.textContent = message;
      }
    });
  }

  function apply() {
    frame = 0;
    restore();
    if (factor !== 1) {
      const rootSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const sizes = [];
      document.querySelectorAll(selector).forEach(element => {
        if (element.closest(excluded)) return;
        const isTextInput = element.matches('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),textarea,select');
        const hasText = [...element.childNodes].some(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (!hasText && !isTextInput) return;
        const baseline = parseFloat(getComputedStyle(element).fontSize);
        if (!Number.isFinite(baseline) || !(rootSize > 0)) return;
        const inline = element.style.getPropertyValue('font-size');
        originals.set(element, inline ? {value: inline, priority: element.style.getPropertyPriority('font-size')} : null);
        sizes.push([element, baseline / rootSize]);
      });
      sizes.forEach(([element, rem]) => element.style.setProperty('font-size', `${rem * factor}rem`, 'important'));
    }
    syncControls();
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(apply);
  }

  function start() {
    document.addEventListener('click', event => {
      const button = event.target.closest?.('[data-wa-reading] button');
      if (!button) return;
      const reset = button.hasAttribute('data-wa-size-reset');
      if (!reset && !button.hasAttribute('data-wa-size')) return;
      factor = reset ? 1 : valid(button.dataset.waSize);
      lastNotice = reset ? 'reset' : 'current';
      try {
        if (reset) localStorage.removeItem(key);
        else localStorage.setItem(key, String(factor));
        storageAvailable = true;
      } catch (_) { storageAvailable = false; }
      if (frame) cancelAnimationFrame(frame);
      apply();
    });
    window.addEventListener('storage', event => {
      if (event.key !== key && event.key !== null) return;
      factor = valid(event.key === null ? null : event.newValue);
      lastNotice = 'current';
      schedule();
    });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('resize', schedule, {passive: true});
    const observer = new MutationObserver(records => {
      if (records.some(record => {
        const element = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        if (!element || element.closest('[data-wa-reading]')) return false;
        return element.closest('#MainContent,footer') || [...record.addedNodes].some(node => node.nodeType === Node.ELEMENT_NODE && (node.matches('#MainContent,footer,[data-wa-reading]') || node.querySelector('#MainContent,footer,[data-wa-reading]')));
      })) schedule();
    });
    observer.observe(document.body, {childList: true, characterData: true, subtree: true});
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
